import { RenderModalFunctionParams, WithModal } from "@amzn/stencil-react-components/modal";
import { PageHeaderButton } from "@amzn/stencil-react-components/page";
import { IconNotification } from "@amzn/stencil-react-icons";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

import { PolicyModal } from "./PolicyModal";

export const AiPolicyModalButton: FC = () => {
  const renderModal = ({ close }: RenderModalFunctionParams) => (
    <PolicyModal
      policy={getString("policy.ai.policies")}
      policyTitle={getString("policy.ai.modal.title")}
      policyType="ai"
      close={close}
      shouldHaveAcknowledgeButton={false}
      shouldHaveDismissButton={true}
    />
  );
  return (
    <WithModal renderModal={renderModal}>
      {({ open }) => (
        <PageHeaderButton onClick={open} icon={<IconNotification />}>
          {getString("policy.ai.title")}
        </PageHeaderButton>
      )}
    </WithModal>
  );
};
